import commApi from "@/api/apis/common.js";
import Vue from 'vue'
// 生成32位字符串
export function getRandomStr32() {
  var arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
  var str_nums = "";
  for (var i = 0; i < 32; i++) {
    var id = parseInt(Math.random() * (arr.length - 1));
    str_nums += arr[id];
  }
  return str_nums;
}

// 微信授权登录
export function wxUserInfoAuthorize(callbackURL, wxAppId, state) {
  var redirect = encodeURIComponent(callbackURL || window.location.href);
  var state = state || 1;
  window.location.replace("https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + wxAppId + "&redirect_uri=" + redirect + "&response_type=code&scope=snsapi_userinfo&state=" + state + "#wechat_redirect");
}

// 加载地图
/*
* @param {Function} callback 回调函数名称，回调函数将会挂载到window上，例如：window.initBaiduMapScript，在方法中就能拿到BMap对象
*/
export function loadBMap(callback) {
  var script = document.createElement('script');
  script.src = 'https://api.map.baidu.com/api?v=2.0&ak=yoQWRQfnnCyGGrxiNmWHvtKXxgziumIM&callback=' + callback;
  document.body.appendChild(script);
}

// 友盟统计
export function loadStat() {
  console.log("友盟统计暂未提供链接！");
  return;
  var script = document.createElement('script');
  script.src = 'https://v1.cnzz.com/z_stat.php?id=1280689875';
  document.body.appendChild(script);

  // var script1 = document.createElement('script');
  // script1.src = 'https://c.cnzz.com/core.php?web_id=1280689875&t=z';
  // document.body.appendChild(script1);
  // 文字形式
  // document.write(unescape("%3Cspan id='cnzz_stat_icon_1280689875'%3E%3C/span%3E%3Cscript src='https://v1.cnzz.com/z_stat.php%3Fid%3D1280689875' type='text/javascript'%3E%3C/script%3E"));
  // 图片形式1
  // document.write(unescape("%3Cspan id='cnzz_stat_icon_1280689875'%3E%3C/span%3E%3Cscript src='https://v1.cnzz.com/z_stat.php%3Fid%3D1280689875%26show%3Dpic' type='text/javascript'%3E%3C/script%3E"));
  // 图片形式2
  // document.write(unescape("%3Cspan id='cnzz_stat_icon_1280689875'%3E%3C/span%3E%3Cscript src='https://v1.cnzz.com/z_stat.php%3Fid%3D1280689875%26show%3Dpic1' type='text/javascript'%3E%3C/script%3E"));
  // 图片形式3
  // document.write(unescape("%3Cspan id='cnzz_stat_icon_1280689875'%3E%3C/span%3E%3Cscript src='https://v1.cnzz.com/z_stat.php%3Fid%3D1280689875%26show%3Dpic2' type='text/javascript'%3E%3C/script%3E"));
}

// 友盟打开app
export function initOpenApplicationFun(DomId, params) {
  var mpscheme = "meipian://main.app.new/meipian?path=meipian%253A%252F%252Farticle%252Fdetail%253Fmask_id%253D3h5c9hhy%2526cb_create_at%253D1618909940%2526cb_expire_time%253D1800%2526client_type%253D2%2526type%253Dwechat%2526source%253Dh5wx_article_top&_sdk_=umeng&um_tc=f46a890aa43c404b95565ea58e9c3e2d&_valid_user_id_=4-c2afd3a446004288a60db5e802ec6c71&_linkid_=usr1lv957v7an79o&source=h5wx_article_top&_bizType_=ushare"

  var oid = "";
  if (localStorage && localStorage.setItem && localStorage.getItem) {
    oid = localStorage.getItem('_umeng_oid') || ((+new Date()).toString(36) + Math.random().toString(36).substr(2, 6));
    localStorage.setItem('_umeng_oid', oid);
  }
  //document.getElementById('oid').innerText = 'umtestid_'+oid;
  var data = ULink.getUriDecodeParams();
  var tm = parseInt(data.timeout);
  var lazy = (data.lazy === 'true' ? true : false);
  if (Object.is(tm, NaN)) {
    tm = undefined;
  }
  var auto = (data.auto === 'true' ? true : false);
  var tip = data.tip;
  var tipitem;
  var clp;
  if (data.clp === 'true') {
    clp = true;
  } else if (data.clp === 'false') {
    clp = false;
  } else if (data.clp === 'function') {
    clp = function (clptoken) {
      return mpscheme + '&umclp=' + clptoken;
    }
  }
  function proxyOpenDownloadfn(defaultAction, cctx) {
    if (data.popup === 'true') {
      defaultAction();
    } else {
      if (cctx.solution.type === 'scheme') {
        if (ULink.isWechat || ULink.isQQ) {
          defaultAction();
        } else {
          location.href = cctx.solution.downloadUrl
        }
      }
    }
  }
  if (tip === 'default') {
    tipitem = tip;
  } else if (tip === 'function') {
    tipitem = function (ctx) {
      return `<div style="position:fixed;left:0;top:0;background:rgba(255,0,255,0.5);width:100%;height:100%;z-index:19910324;">${ctx.solution.downloadUrl}</div>`;
    }
  }
  if (data.env === 'pre') {
    ULink.setGateway('https://pre-c.umsns.com');
  }

  ULink({
    id: data.linkid || 'usr1lv957v7an79o',
    data: params,
    selector: '#' + DomId,
    timeout: 2000,
    useOpenInBrowerTips: tipitem || 'default',
    lazy: true,
    auto: auto,
    useClipboard: clp,
    proxyOpenDownload: proxyOpenDownloadfn,
    onready: function (ctx) {
      // 点击按钮事件
      // alert('12')
      console.log('ready', ctx);
      // document.getElementById('J_solutionBox').innerText = JSON.stringify(ctx.solution, null, 2);
    }
  })
}

// 深度复制
export function deepClone(obj) {
  let result = Array.isArray(obj) ? [] : {}
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object') {
        result[key] = obj[key] !== null ? deepClone(obj[key]) : obj[key]
      } else {
        result[key] = obj[key]
      }
    }
  }
  return result
}

// 验证是否是手机号
export function testMobilePhone(phoneNum) {
  // var reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
  var reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  return reg.test(phoneNum);
}

/* 获取URL中的某个参数 */
export function getUrlParamByKey(key) {
  var str = window.location.href;
  if (str.indexOf('?') > -1) {
    str = str.split('?')[1];
    var list = str.split("&");
    for (var i = 0; i < list.length; i++) {
      var k = list[i].split("=")[0];
      var v = list[i].split("=")[1];
      if (k == key) return v;
    }
  }
  return null;
}

// 获取URL中的全部参数
export function getUrlParamObj(url) {
  var arr = [];
  var query = {};
  if (url.indexOf('?') > -1) {
    arr = url.split('?')[1];
    if (arr.length > 0) {
      var list = arr.split("&");
      list.length > 0 && list.forEach(item => {
        let mm = item.split('='),
          key = mm[0],
          value = mm[1];
        query[key] = value
      });
    }
  }
  return query;
}

/* 获取选项标签 */
export function getSelectLabel(index) {
  var list = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
  return list[index];
}

// 点击量
// contentType == 4直播，5图文，6图集，7专题，8占位广告，9视频，11音频，12外链，15，17问答 等类型的加点击量，其他类型的不用加
export function clickPlayCount(params) {
  var p = {
    categoryType: 0, // 栏目类型:0、普通栏目；1、首页栏目；2、精品栏目 3、推广栏目
    channelId: '', // 栏目id
    channelName: '', // 栏目名称
    contentCreationTime: '', // 创建时间
    contentId: '', // 稿件Id
    contentTitle: '', // 稿件title
    contentType: '', // 内容类型: 1、活动；2、抽奖；3、投票调查；4、直播间；5、图文资讯；6、图集;7、专题；8、占位广告；9、视频 ；10、问卷调查；11、音频； 12、外链；13、自媒体；16、报料 ,17弹窗广告,18:启动页广告
    deviceId: '', // 设备id
    deviceType: 4, // 设备标识1:华为2:小米3:苹果4：未知
    memberId: null, // 当前稿件的编辑者的id
    nickName: '', // 当前稿件的编辑者的用户名称
    sourceType: 4, // 1:苹果;2:安卓;3web;4:H5
  }

  params = Object.assign(p, params);
  params.deviceId = window.localStorage.getItem("xc-share-deviceId");

  commApi
    .clickPlayCount(params)
    .then((res) => {
      console.log("统计成功，访问量+1！");
    })
    .catch((err) => {
      console.log("统计成功，访问量+1！");
    });
}

// 增加积分
export function addScore(params) {
  var p = {
    code: "", // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、gkyp、zbj、dy、dz、sc)
    description: "", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、观看音频、直播间、订阅、点赞、收藏)
    contentType: "", // 非必传，稿件的type
    contentId: "", // 非必传，稿件的id
    contentName: "", // 非必传，稿件的标题
    // deviceId:, // 设备id，客户端则传设备id，静态页不传
    memberId: null, // 必传，会员id
  };
  params = Object.assign(p, params);

  commApi
    .addScore(params)
    .then((res) => {
      if (res.suc == 1) {
        console.log("积分添加成功！");
      } else {
        console.log(res.message);
      }
    })
    .catch((err) => {
      console.log("积分添加失败！");
    });
}
//获取uid
export function getUuid(len, radix) {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}
/* 微信二次分享 */
export function wechatShare(shareUrl,title,introduction,sharePictureUrl) {

  let shareUrlHref=shareUrl||location.href
  commApi.getWeiXinTicket({
    nodeCode: process.env.VUE_APP_NODE_CODE,
    url: shareUrlHref
  }).then((res) => {
    Vue.prototype.$WeiXin.shareWeiXin(res, title, introduction, shareUrlHref, sharePictureUrl);
  }).catch((err) => {

  })
}